import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function BuddyAvanzaAUP() {
  return (
    <LegalPageLayout
      documentKey="aup"
      testid="legal-aup"
      eyebrow="Documento legal"
      documentTitle="Política de Uso Responsable de BUDDY AVANZA"
      intro="BUDDY AVANZA está diseñado para aprender, no para sustituir al estudiante. Esta política describe qué usos son adecuados y cuáles no lo son."
    >
      {({ contactEmail }) => (<>
        <section>
          <h2>1. Mensaje central</h2>
          <p><strong>BUDDY AVANZA está diseñado para aprender, no para
             sustituir al estudiante.</strong> Buddy y las herramientas de la
             plataforma acompañan el proceso educativo; no reemplazan al
             docente ni al esfuerzo del estudiante.</p>
        </section>

        <section>
          <h2>2. Usos permitidos</h2>
          <ul>
            <li>Pedir explicaciones y aclaraciones sobre un tema.</li>
            <li>Solicitar pistas para avanzar en la resolución de un problema.</li>
            <li>Analizar procedimientos y comprender conceptos.</li>
            <li>Practicar con ítems, simulaciones y refuerzos.</li>
            <li>Identificar errores y reflexionar sobre ellos.</li>
            <li>Recibir orientación paso a paso cuando esté disponible.</li>
            <li>Utilizar a Buddy como acompañamiento educativo.</li>
          </ul>
        </section>

        <section>
          <h2>3. Usos no permitidos</h2>
          <ul>
            <li>Intentar obtener fraudulentamente respuestas de evaluaciones que se encuentren restringidas.</li>
            <li>Vulnerar o intentar vulnerar mecanismos de seguridad del servicio.</li>
            <li>Acceder o intentar acceder a cuentas de terceros.</li>
            <li>Compartir credenciales personales.</li>
            <li>Extraer masivamente contenidos, ítems o preguntas.</li>
            <li>Manipular resultados, indicadores o simulaciones.</li>
            <li>Automatizar respuestas mediante bots u otros mecanismos.</li>
            <li>Evadir restricciones o controles internos del servicio.</li>
            <li>Utilizar el servicio con fines ilícitos.</li>
            <li>Intentar comprometer la infraestructura o los servicios de terceros asociados.</li>
          </ul>
        </section>

        <section>
          <h2>4. Cómo funciona Buddy</h2>
          <p>Buddy puede:</p>
          <ul>
            <li>Hacer preguntas para guiar el razonamiento.</li>
            <li>Ofrecer pistas graduadas.</li>
            <li>Guiar procedimientos paso a paso.</li>
            <li>Ayudar a analizar errores.</li>
            <li>Acompañar el proceso de aprendizaje.</li>
          </ul>
          <p>Buddy no está diseñado simplemente para responder por el
             estudiante.</p>
        </section>

        <section>
          <h2>5. Integridad de las evaluaciones</h2>
          <p>Durante determinadas evaluaciones y simulaciones, algunas
             funciones de asistencia pueden restringirse para preservar la
             finalidad diagnóstica de la actividad. Estas restricciones
             forman parte del diseño pedagógico del producto y buscan que
             los resultados reflejen el desempeño real del estudiante.</p>
        </section>

        <section>
          <h2>6. Consecuencias</h2>
          <p>El incumplimiento de esta política puede dar lugar a la
             restricción o suspensión del acceso al servicio, sin perjuicio
             de otras acciones que correspondan conforme a la legislación
             aplicable.</p>
        </section>

        <section>
          <h2>7. Contacto</h2>
          <p>Para reportar un uso indebido o consultas sobre esta política
             puedes escribir a{" "}
             <a href={`mailto:${contactEmail}`} data-testid="aup-contact-email">{contactEmail}</a>.</p>
        </section>
      </>)}
    </LegalPageLayout>
  );
}
